module.exports = __webpack_public_path__ + "static/self-help-tools@3x-76c178b36f0df3ae5bf1495d2916e491.png";